<script lang="ts">
	import FileItem from './FileItem.svelte'
	import { fadeHeight } from '@repo/commons/utils'
	import type { IconName } from '$lib_commons/svg-icons/iconsMap.ts'
	import type { FileStatusType } from '@repo/commons/models'

	interface StatusLabels {
		uploaded?: {
			label: string
			icon?: IconName
		}
		warnings?: {
			label: string
			icon?: IconName
		}
		errors?: {
			label: string
			icon?: IconName
		}
	}

	interface Props {
		items: {
			id: string
			file: File
			status: FileStatusType
			progress?: number
			icon?: IconName
			subtitle?: string
			warnings?: { group: string; warnings: string[] }[]
			errors?: { group: string; errors: string[] }[]
		}[]
		removable?: boolean
		showProgress?: boolean
		statusLabels?: StatusLabels
		variant?: 'default' | 'wide'
		borderless?: boolean
		onRemoveFile?: (fileIndex: number) => void
		onRetryFile?: (fileId: string) => void
		/** Adjusts how slow or fast progress simulation runs.
		 *  e.g. 1 = normal, 1.5 = 50% slower, 0.7 = faster */
		simulationMultiplier?: number
	}

	let {
		items = [],
		onRemoveFile = () => {},
		onRetryFile,
		statusLabels,
		showProgress = false,
		removable = true,
		variant = 'default',
		borderless = false,
		simulationMultiplier = 1
	}: Props = $props()
</script>

<div class="file-list">
	{#each items as item, index (item.id)}
		<div transition:fadeHeight={{ duration: 150 }}>
			<FileItem
				file={item.file}
				status={item.status}
				errors={item.errors}
				warnings={item.warnings}
				icon={item.icon}
				subtitle={item.subtitle}
				progress={item.progress}
				{variant}
				{borderless}
				onRemove={() => onRemoveFile(index)}
				onRetry={onRetryFile ? () => onRetryFile(item.id) : undefined}
				{removable}
				{simulationMultiplier}
				{showProgress}
				{statusLabels}
			/>
		</div>
	{/each}
</div>

<style>
	.file-list {
		@apply flex flex-col;
	}
	.file-list:empty {
		display: none;
	}
</style>
